var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82199 1.17885L1.07199 7.92885C0.881137 8.1197 0.785713 8.3457 0.785713 8.60686C0.785713 8.86803 0.881137 9.09403 1.07199 9.28488C1.26283 9.47573 1.48884 9.57115 1.75 9.57115H17.25C17.5112 9.57115 17.7372 9.47573 17.928 9.28488C18.1189 9.09403 18.2143 8.86803 18.2143 8.60686C18.2143 8.3457 18.1189 8.1197 17.928 7.92885L10.178 1.17885C9.98716 0.988002 9.76116 0.892578 9.5 0.892578C9.23884 0.892578 9.01283 0.988002 8.82199 1.17885ZM14.4722 7.57115L9.5 3.24056L4.52784 7.57115H14.4722Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscend);
export default __webpack_public_path__ + "static/media/sort-ascend.0a7d6fac2142dc220152c93abd6d70fd.svg";
export { ForwardRef as ReactComponent };